// preventDefaultEvents.tsx
import React from 'react';

const preventDefaultEvents = (WrappedComponent: React.ComponentType<any>) => {
  return (props: any) => {
    const handleContextMenu = (e: React.MouseEvent<HTMLDivElement>) => {
      e.preventDefault();
    };

    const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
      e.preventDefault();
    };

    return (
      <div
        onContextMenu={handleContextMenu}
        onDragStart={handleDragStart}
        style={{
          display: 'inline-block',
          touchAction: 'manipulation', 
          WebkitTouchCallout: 'none',
          userSelect: 'none',
        }}
      >
        <WrappedComponent {...props} />
      </div>
    );
  };
};

export default preventDefaultEvents;